// IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
// Форма «Стовпчики» вида ячеек отчёта REPORT2: те же слои режима (src/utils/cellViews/*), что и у круга, но каждый слой — отдельный столбик своего цвета
// слева в ячейке-дате, число справа. Высота столбика ∝ значению слоя по той же шкале / группе, что у круга (cellRing_scale: max группы; проценты —
// полный столбик = 100 %); сигналы (непокрыто, сверхнорматив, > 100 % …) — цветная полоса над столбиками вместо кольца (тот же приоритет cellRing_ring).
// Узкая колонка (числу нет места) — только столбики по центру, число — в Alt-подсказке. Чистые функции (без Vue и DOM) — tests/unit/cellBars.test.mjs
import { cellRing_ring, cellRing_tone, cellChart_fillHeight } from '@/utils/cellRing'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)

export const CELL_BARS_MIN_H = 2     // минимальная высота столбика положительного слоя
export const CELL_BARS_GAP = 1
export const CELL_BARS_BAND_H = 2    // полоса сигнала
export const CELL_BARS_W_MIN = 2
export const CELL_BARS_W_MAX = 6
export const CELL_BARS_NUM_ROOM = 28 // место под число справа от столбиков

const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const isNum = (v) => v !== undefined && v !== null && v !== '' && Number.isFinite(Number(v))

// высота области столбиков: высота ячейки − 4 (поля) − полоса сигнала с зазором
export function cellBars_maxHeight(size) {
    const h = num(size && size.cellH)
    return Math.max(0, Math.round(h) - 4 - CELL_BARS_BAND_H - 1)
}

// ширина столбика и слота под n столбиков: слот не шире 40 % ячейки (6…40 px), столбик 2…6 px
export function cellBars_geometry(n, size) {
    const k = Math.max(1, Math.floor(num(n)))
    const cellW = num(size && size.cellW)
    const maxSlot = Math.max(6, Math.min(40, Math.floor((cellW > 0 ? cellW : 60) * 0.4)))
    const bw = Math.max(CELL_BARS_W_MIN, Math.min(CELL_BARS_W_MAX, Math.floor((maxSlot - CELL_BARS_GAP * (k - 1)) / k)))
    return { bw, slot: k * bw + CELL_BARS_GAP * (k - 1) }
}

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
// opts.fill (флаг fe.ux.cellChartFillRow): область столбиков на всю высоту строки (cellChart_fillHeight), столбик шире в высоких строках (≈ 0.3 высоты,
// 6…10 px), слот не шире 40 % ячейки, но не уже прежнего; ячейка в своём масштабе (самый высокий слой = полный
// столбик; проценты — 100 % = полный); over-100 и доля — по шкале группы, как раньше
export const CELL_BARS_FILL_W_MAX = 10
export function cellBars_fillGeometry(n, size) {
    const k = Math.max(1, Math.floor(num(n)))
    const H = cellChart_fillHeight(size && size.cellH)
    const old = cellBars_geometry(k, size)
    const cellW = num(size && size.cellW)
    const wMax = Math.max(CELL_BARS_W_MAX, Math.min(CELL_BARS_FILL_W_MAX, Math.round(H * 0.3)))
    const maxSlot = Math.floor((cellW > 0 ? cellW : 60) * 0.4)
    const bw = Math.max(old.bw, Math.min(wMax, Math.floor((maxSlot - CELL_BARS_GAP * (k - 1)) / k)))
    return { bw, slot: k * bw + CELL_BARS_GAP * (k - 1), H }
}

// layers, scale, signals, size → { bars: [{ key, title, x, w, h, color, value }], slot, hMax, signalBand ({ kind, color, h } | null), only, value, share, over } | null.
// opts: { value — значение ячейки (over-100 и доля; иначе Σ положительных слоёв), sizeValue — у круга размер, у столбиков не нужен (каждый слой — свой),
// fixedDiameter — status_dot: без шкалы, столбики — доли слоёв от их суммы, высота не больше fixedDiameter × 1.5 }
export function cellBars_build(layers, scale, signals, size, opts = {}) {
    const pos = (Array.isArray(layers) ? layers : []).filter(l => num(l && l.value) > 0)
    if (!pos.length) return null
    const sum = pos.reduce((s, l) => s + num(l.value), 0)
    const value = isNum(opts.value) ? Number(opts.value) : sum
    const cellW = num(size && size.cellW)
    const fill = !!opts.fill && cellChart_fillHeight(size && size.cellH) > CELL_BARS_BAND_H + 1   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
    const fg = fill ? cellBars_fillGeometry(pos.length, size) : null
    let hMax = fill ? fg.H - CELL_BARS_BAND_H - 1 : cellBars_maxHeight(size)
    if (!(hMax > 0)) return null
    const fixed = Number(opts.fixedDiameter)
    const isFixed = isNum(opts.fixedDiameter) && fixed > 0
    const kind = (scale && scale.kind) || 'qty'
    let full
    if (isFixed) {
        hMax = Math.max(CELL_BARS_MIN_H, Math.min(hMax, Math.round(fixed * 1.5)))
        full = sum
    } else {
        full = kind === 'pct' ? (num(scale && scale.unit) > 0 ? num(scale.unit) : 100) : num(scale && scale.max)
        if (!(full > 0)) full = Math.max(...pos.map(l => num(l.value)))   // шкалы нет — самый высокий слой = полный столбик
    }
    const { bw, slot } = fg || cellBars_geometry(pos.length, size)
    const fullH = fill && !isFixed && kind !== 'pct' ? Math.max(...pos.map(l => num(l.value))) : full   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі): своя шкала ячейки
    const bars = pos.map((l, i) => {
        const v = num(l.value)
        const h = Math.max(CELL_BARS_MIN_H, Math.round(hMax * Math.min(1, v / fullH)))
        return { key: l.key, title: l.title, x: i * (bw + CELL_BARS_GAP), w: bw, h: Math.min(h, hMax), color: cellRing_tone(l.color || '#9e9e9e', l.tone), value: v }
    })
    const share = !isFixed && full > 0 ? Math.abs(value) / full : 0
    const over = !isFixed && share > 1 + 1e-9
    const sig = Array.isArray(signals) ? signals.slice() : []
    if (over) sig.push({ kind: 'over-100' })
    const ring = cellRing_ring(sig)
    const signalBand = ring ? { kind: ring.kind, color: ring.color, h: CELL_BARS_BAND_H } : null
    return { bars, slot, hMax, signalBand, only: cellW > 0 && cellW < (fg ? cellBars_geometry(pos.length, size).slot : slot) + CELL_BARS_NUM_ROOM, value, share, over }   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі): «только столбики» — по прежнему слоту
}

// подпись геометрии (кеш DOM: перестраивать содержимое .cell-bars только при изменении)
export function cellBars_sig(out) {
    if (!out) return ''
    const b = out.signalBand ? `${out.signalBand.color}` : ''
    return `${out.slot}|${out.hMax}|${b}|` + out.bars.map(x => `${x.x},${x.w},${x.h},${x.color}`).join(';')
}

// содержимое .cell-bars (HTML): столбики снизу, полоса сигнала сверху на всю ширину слота. Цвета — только #hex / rgb() / имена (экранируются кавычки)
export function cellBars_html(out) {
    if (!out) return ''
    const esc = (s) => String(s).replace(/[<>"'&]/g, '')
    let html = ''
    if (out.signalBand) html += `<b class="cell-bars-band" style="height:${out.signalBand.h}px;background:${esc(out.signalBand.color)}"></b>`
    for (const x of out.bars) html += `<i style="left:${x.x}px;width:${x.w}px;height:${x.h}px;background:${esc(x.color)}"></i>`
    return html
}
